<template>
  <div class="py-5 section-parallax" id="transparencia">
    <div class="container-fluid my-5 bg-light p-4 text-center">
      <div class="row align-items-center justify-content-center" style="height:15vh;">
        <div class="col-md-12">
          <h1 class="text-black">TRANSPARÊNCIA</h1>
        </div>
      </div>
      <div class="row text-center align-items-center">
        <div class="col-md-4 animate-in-left">
          <!--<a class="btn btn-outline-primary btn-lg m-2" data-toggle="collapse" data-target="#collapseMunicipal"
             aria-expanded="false"
             aria-controls="collapseMunicipal">LEGISLAÇÃO MUNICIPAL</a>-->
          <b-button v-b-toggle.collapseMunicipal class="btn btn-outline-primary btn-lg m-2">LEGISLAÇÃO MUNICIPAL</b-button>
        </div>
        <div class="col-md-4">
          <!--<a class="btn btn-outline-primary btn-lg m-2" data-toggle="collapse" data-target="#collapseEstadual"
             aria-expanded="false"
             aria-controls="collapseEstadual">LEGISLAÇÃO ESTADUAL</a>-->
          <b-button v-b-toggle.collapseEstadual class="btn btn-outline-primary btn-lg m-2">LEGISLAÇÃO ESTADUAL</b-button>
        </div>
        <div class="col-md-4 animate-in-right">
          <!--<a class="btn btn-outline-primary btn-lg m-2" data-toggle="collapse" data-target="#collapseFederal"
             aria-expanded="false"
             aria-controls="collapseFederal">LEGISLAÇÃO FEDERAL</a>-->
          <b-button v-b-toggle.collapseFederal class="btn btn-outline-primary btn-lg m-2">LEGISLAÇÃO FEDERAL</b-button>
        </div>
      </div>

      <div id="accordionLegislacao">
        <b-collapse id="collapseMunicipal" data-target="#collapseMunicipal" aria-labelledby="headingLegislacao"
             data-parent="#accordionLegislacao" accordion="accordionLegislacao">
          <div class="col-md-12 text-left">
            <div class="card">
              <div class="card-body">
                <h5 class="card-title">Legislação COVID-19 no âmbito Municipal</h5>
                <!--<p class="card-text">Legislação COVID-19 no ambito Municipal</p>-->
                <a class="btn btn-primary"
                   href="https://www.toledo.pr.gov.br/coe/decretos"
                   target="_blank">Acesse o documento aqui</a>
              </div>
            </div>
          </div>
        </b-collapse>
        <b-collapse id="collapseEstadual" data-target="#collapseEstadual" aria-labelledby="headingLegislacao"
             data-parent="#accordionLegislacao" accordion="accordionLegislacao">
          <div class="row">
            <div class="col-md-12 text-center">
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title">Legislação COVID-19 no âmbito Estadual</h5>
                  <!--<p class="card-text">Legislação COVID-19 no ambito Estadual</p>-->
                  <a class="btn btn-primary"
                     href="http://www.coronavirus.pr.gov.br/Campanha/Pagina/TRANSPARENCIA-Enfrentamento-ao-Coronavirus-3"
                     target="_blank">Acesse o documento aqui</a>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
        <b-collapse id="collapseFederal" data-target="#collapseFederal" aria-labelledby="headingLegislacao"
             data-parent="#accordionLegislacao" accordion="accordionLegislacao">
          <div class="row">
            <div class="col-md-12 text-right">
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title">Legislação COVID-19 no âmbito Federal</h5>
                  <!--<p class="card-text">Legislação COVID-19 no ambito Federal</p>-->
                  <a class="btn btn-primary"
                     href="http://www.planalto.gov.br/CCIVIL_03/Portaria/quadro_portaria.htm"
                     target="_blank">Acesse o documento aqui</a>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </div>
      <hr/>

      <!--<div class="row">
        <div class="col-md-12">
          <a class="btn btn-primary btn-lg m-2" href="http://equiplano.toledo.pr.gov.br:7474/transparencia/publicacoesCovid19/downloadDocumento?formulario.idAnexo=1" target="_blank">PLANO MUNICIPAL DE VACINAÇÃO CONTRA O COVID-19</a>
        </div>
      </div>-->
	  
      <div class="row">
        <div class="col-md-12">
          <a class="btn btn-primary btn-lg m-2" href="http://equiplano.toledo.pr.gov.br:7474/transparencia/publicacoesCovid19" target="_blank">VACINAÇÃO COVID-19</a>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <a class="btn btn-primary btn-lg m-2" href="http://equiplano.toledo.pr.gov.br:7474/transparencia/licitacoesCovid19" target="_blank">LICITAÇÕES</a>
          <!--<a class="btn btn-primary btn-lg m-2" href="#register">ORÇAMENTO</a>-->
          <a class="btn btn-primary btn-lg m-2" href="http://equiplano.toledo.pr.gov.br:7474/transparencia/receitaCovid19" target="_blank">RECEITAS</a>
          <a class="btn btn-primary btn-lg m-2" href="http://equiplano.toledo.pr.gov.br:7474/transparencia/despesaCovid19" target="_blank">DESPESAS</a>
          <!--<a class="btn btn-primary btn-lg m-2" href="#register">RECURSOS HUMANOS</a>-->
          <!--<a class="btn btn-primary btn-lg m-2" href="#schedule">PUBLICIDADE</a>-->
          <a class="btn btn-primary btn-lg m-2" href="https://www.toledo.pr.gov.br/pagina/educacao-0" target="_blank">EDUCAÇÃO</a>-
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "Bloco8Transparencia"
}
</script>

<style scoped>
.btn-outline-primary {
  color: #12bbad;
  background-color: transparent;
  background-image: none;
  border-color: #12bbad; }
.btn-outline-primary:hover {
  color: #fff;
  background-color: #12bbad;
  border-color: #12bbad; }
.btn-outline-primary:focus, .btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(18, 187, 173, 0.5); }
.btn-outline-primary.disabled, .btn-outline-primary:disabled {
  color: #12bbad;
  background-color: transparent; }
/*.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .btn-outline-primary.dropdown-toggle {
  color: #fff;
  background-color: #12bbad;
  border-color: #12bbad; }*/
/*.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(18, 187, 173, 0.5); }*/

.btn-primary {
  color: #fff;
  background-color: #12bbad;
  border-color: #12bbad;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075); }
.btn-primary:hover {
  color: #fff;
  background-color: #0f988d;
  border-color: #0e8c82; }
.btn-primary:focus, .btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(18, 187, 173, 0.5); }
.btn-primary.disabled, .btn-primary:disabled {
  color: #fff;
  background-color: #12bbad;
  border-color: #12bbad; }
.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #0e8c82;
  border-color: #0c8177; }
.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus,
.show > .btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(18, 187, 173, 0.5); }

</style>